"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interpolatePoint = interpolatePoint;
exports.lineStringCoordinateAtM = lineStringCoordinateAtM;
exports.lineStringsCoordinateAtM = lineStringsCoordinateAtM;

var _array = require("../../array.js");

var _math = require("../../math.js");

/**
 * @module ol/geom/flat/interpolate
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} fraction Fraction.
 * @param {Array<number>} [opt_dest] Destination.
 * @param {number} [opt_dimension] Destination dimension (default is `2`)
 * @return {Array<number>} Destination.
 */
function interpolatePoint(flatCoordinates, offset, end, stride, fraction, opt_dest, opt_dimension) {
  var o, t;
  var n = (end - offset) / stride;

  if (n === 1) {
    o = offset;
  } else if (n === 2) {
    o = offset;
    t = fraction;
  } else if (n !== 0) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    var length_1 = 0;
    var cumulativeLengths = [0];

    for (var i = offset + stride; i < end; i += stride) {
      var x2 = flatCoordinates[i];
      var y2 = flatCoordinates[i + 1];
      length_1 += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
      cumulativeLengths.push(length_1);
      x1 = x2;
      y1 = y2;
    }

    var target = fraction * length_1;
    var index = (0, _array.binarySearch)(cumulativeLengths, target);

    if (index < 0) {
      t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
      o = offset + (-index - 2) * stride;
    } else {
      o = offset + index * stride;
    }
  }

  var dimension = opt_dimension > 1 ? opt_dimension : 2;
  var dest = opt_dest ? opt_dest : new Array(dimension);

  for (var i = 0; i < dimension; ++i) {
    dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, _math.lerp)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
  }

  return dest;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} m M.
 * @param {boolean} extrapolate Extrapolate.
 * @return {import("../../coordinate.js").Coordinate|null} Coordinate.
 */


function lineStringCoordinateAtM(flatCoordinates, offset, end, stride, m, extrapolate) {
  if (end == offset) {
    return null;
  }

  var coordinate;

  if (m < flatCoordinates[offset + stride - 1]) {
    if (extrapolate) {
      coordinate = flatCoordinates.slice(offset, offset + stride);
      coordinate[stride - 1] = m;
      return coordinate;
    } else {
      return null;
    }
  } else if (flatCoordinates[end - 1] < m) {
    if (extrapolate) {
      coordinate = flatCoordinates.slice(end - stride, end);
      coordinate[stride - 1] = m;
      return coordinate;
    } else {
      return null;
    }
  } // FIXME use O(1) search


  if (m == flatCoordinates[offset + stride - 1]) {
    return flatCoordinates.slice(offset, offset + stride);
  }

  var lo = offset / stride;
  var hi = end / stride;

  while (lo < hi) {
    var mid = lo + hi >> 1;

    if (m < flatCoordinates[(mid + 1) * stride - 1]) {
      hi = mid;
    } else {
      lo = mid + 1;
    }
  }

  var m0 = flatCoordinates[lo * stride - 1];

  if (m == m0) {
    return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
  }

  var m1 = flatCoordinates[(lo + 1) * stride - 1];
  var t = (m - m0) / (m1 - m0);
  coordinate = [];

  for (var i = 0; i < stride - 1; ++i) {
    coordinate.push((0, _math.lerp)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
  }

  coordinate.push(m);
  return coordinate;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} m M.
 * @param {boolean} extrapolate Extrapolate.
 * @param {boolean} interpolate Interpolate.
 * @return {import("../../coordinate.js").Coordinate|null} Coordinate.
 */


function lineStringsCoordinateAtM(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
  if (interpolate) {
    return lineStringCoordinateAtM(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
  }

  var coordinate;

  if (m < flatCoordinates[stride - 1]) {
    if (extrapolate) {
      coordinate = flatCoordinates.slice(0, stride);
      coordinate[stride - 1] = m;
      return coordinate;
    } else {
      return null;
    }
  }

  if (flatCoordinates[flatCoordinates.length - 1] < m) {
    if (extrapolate) {
      coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
      coordinate[stride - 1] = m;
      return coordinate;
    } else {
      return null;
    }
  }

  for (var i = 0, ii = ends.length; i < ii; ++i) {
    var end = ends[i];

    if (offset == end) {
      continue;
    }

    if (m < flatCoordinates[offset + stride - 1]) {
      return null;
    } else if (m <= flatCoordinates[end - 1]) {
      return lineStringCoordinateAtM(flatCoordinates, offset, end, stride, m, false);
    }

    offset = end;
  }

  return null;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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